<template>
  <q-card flat>
    <q-card-section>
      <SelectDateRange :visible-comment="false" @date-range-selected="loadReport"/>
    </q-card-section>
  </q-card>
</template>

<script>
import SelectDateRange from "@/components/dashboard/SelectDateRange.vue";

export default {
  name: "ReportViewer",
  components: {SelectDateRange},
  data(){
    return{
      reportContent: undefined
    }
  },
  methods:{
    async loadReport(args){
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/%DA%AF%D8%B2%D8%A7%D8%B1%D8%B4%D8%A7%D8%AA%20%D8%AA%D8%A7%D9%85%DB%8C%D9%86%20%DA%A9%D9%86%D9%86%D8%AF%DA%AF%D8%A7%D9%86/%DA%AF%D8%B2%D8%A7%D8%B1%D8%B4%20%D8%AA%D8%A7%D9%85%DB%8C%D9%86%20%DA%A9%D9%86%D9%86%D8%AF%DA%A9%D8%A7%D9%86%20%DA%AF%D8%B1%D9%88%D9%87%20%D9%87%D8%A7%DB%8C%20%DA%A9%D8%A7%D9%84%D8%A7?rs:Format=PDF&StartDate=${args.startDate}&EndDate=${args.endDate}&rc:Parameters=False&rc:Zoom=Page Width`)
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>